import Joi from 'joi';
import schemas from '../fields/definedSchemas';

const fields = {
    school_name: {
        ...schemas.radioRequired,
        label: 'What is the name of the CPR/FA organization?',
        section: 'CPR',
        options: {
            'American Red Cross': 'American Red Cross',
            'American Heart Association': 'American Heart Association',
        },
        validation: Joi.string().required().messages({
            'any.required': 'Please select a provider from the list.',
        }),
    },
    course_name: {
        ...schemas.selectRequired,
        label: 'What course did you complete?',
        section: 'CPR',
        options: {
            CPR: 'CPR',
            'First Aid': 'First Aid',
            'CPR and First Aid': 'CPR and First Aid',
        },
        validation: Joi.string().required().messages({
            'any.required': 'Please select a course from the list.',
        }),
    },
    issue_date: {
        ...schemas.dateRequiredMaxToday,
        label: 'What day did you complete this course?',
        section: 'CPR',
    },
    been_used_before: {
        ...schemas.boolRequired,
        label: 'Have you already submitted this certiciate in a previous application to the USCG?',
        section: 'CPR',
        validation: schemas.boolRequired.validation.messages({
            'any.required': 'Select an option.',
        }),
    },
};

export default fields;
